module.exports = __webpack_public_path__ + "static/media/33.842d20ce.png";